<template>
  <div>
    <v-card class="elevation-0">
      <v-toolbar card color="white">
        <v-text-field
          flat
          solo
          hide-details
          prepend-icon="search"
          placeholder="Tìm trên danh sách khách hàng"
          v-model="table.searchText"
        ></v-text-field>
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="exportToExcel()">
            <v-icon>save_alt</v-icon>
          </v-btn>
          <span>Tải về danh sách khách hàng</span>
        </v-tooltip>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-data-table
          item-key="id"
          :headers="table.headers"
          :search="table.searchText"
          :items="datasource"
          :rows-per-page-items="[10,20,50,100]"
          :loading="isLoading"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.phone }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.address }}</td>
            <td>{{ props.item.parentAccountName }}</td>
            <td>{{ props.item.parentAccountId }}</td>
            <td>{{ props.item.taxCode }}</td>
            <td>{{ props.item.remark }}</td>
            <td>
              <v-chip
                v-if="props.item.errCode"
                small
                color="red"
                text-color="white"
              >{{props.item.errCode}}</v-chip>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import XLSX from 'xlsx';

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    datasource: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      table: {
        searchText: '',
        headers: [
          {
            text: 'Tên khách hàng',
            value: 'name'
          },
          {
            text: 'SĐT',
            value: 'phone'
          },
          {
            text: 'Email',
            value: 'email'
          },
          {
            text: 'Địa chỉ',
            value: 'address'
          },
          {
            text: 'Nhà phân phối',
            value: 'parentAccountName'
          },
          {
            text: 'Id Nhà phân phối',
            value: 'parentAccountId'
          },
          {
            text: 'Mã số thuế',
            value: 'taxCode'
          },
          {
            text: 'Ghi chú',
            value: 'remark'
          },
          {
            text: 'Lỗi (Nếu có)',
            value: 'errCode'
          }
        ]
      }
    };
  },
  methods: {
    exportToExcel () {
      if (this.datasource.length > 0) {
        let dataToExport = [];
        this.datasource.map((item, index) => {
          let account = {
            STT: ++index,
            'Tên khách hàng': item.name,
            SĐT: item.phone,
            Email: item.email,
            'Địa chỉ': item.address,
            'Tên nhà phân phối': item.parentAccountName,
            'Id Nhà phân phối': item.parentAccountId,
            'MST/CMND': item.taxCode,
            'Ghi chú': item.remark,
            'Lỗi (Nếu có)': item.errCode
          };
          dataToExport.push(account);
          return 0;
        });

        let sheet = XLSX.utils.json_to_sheet(dataToExport);
        let wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, sheet, 'Accounts');
        XLSX.writeFile(wb, 'Accounts.xlsx');
      } else {
        window.getApp.showMessage('Không có dữ liệu', 'error');
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/account/components/importlist.vue